const focusLastTag = ({ state, props, path }) => {
  const tags = state.get(`selectr.${props.namespace}.selected`)
  const tag = tags[tags.length - 1]
  state.set(`selectr.${props.namespace}.focusedTag`, tags.length - 1)
  state.set(
    `selectr.${props.namespace}.selected.${tags.length - 1}.focused`,
    true
  )
}

focusLastTag.displayName = 'focusLastTag'
export default focusLastTag
